<prf-section>
  <prf-h2 class="prf-diagnostics-of-interests-title">{{ diagnosticsOfInterestsData.title }}</prf-h2>
  <prf-description class="prf-diagnostics-of-interests-description">
    {{ diagnosticsOfInterestsData.description }}
  </prf-description>
  <prf-diagnostics-of-interests-slider [sliderCards]="diagnosticsOfInterestsData.sliderCards" />
  <prf-info-block [infoBlockData]="diagnosticsOfInterestsData.infoBlocks" class="prf-diagnostics-of-interests-info-block" />
</prf-section>
